import { useNavigate } from "react-router";
import type { TournamentProps } from "~/helpers/prepare-tournament-data";
import { parseDateRange } from "~/utils/belt";

const DateTournaments: React.FC<{
  selectedDate: Date;
  daysTournaments: { [key: string]: TournamentProps[] };
}> = ({ selectedDate, daysTournaments }) => {
  const navigate = useNavigate();
  return (
    <div className="w-full font-bold">
      <div className="flex">
        <h4 className="text-jiwe-orange dark:text-jiwe-pink uppercase w-fit">
          {selectedDate
            .toLocaleDateString("en-GB", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })
            .split(" ")
            .filter((_, index) => index < 3)
            .join(" ")}
        </h4>
        <div className="bg-jiwe-orange dark:bg-jiwe-pink h-[1px] mt-[0.625rem] ml-4 min-w-[50%] w-[-webkit-fill-available]" />
      </div>
      <div className="flex flex-col mt-6">
        {daysTournaments[selectedDate.toISOString().split("T")[0]] ? (
          daysTournaments[selectedDate.toISOString().split("T")[0]].map(
            (tournament: any) => (
              <div
                className="border-b-[.5px] border-b-divider dark:border-b-divider-dark py-4 max-w-full"
                key={`calendar-${tournament.id}`}
              >
                <button
                  onClick={() => navigate(tournament.id)}
                  type="button"
                  className="cursor-pointer hover:opacity-80 uppercase"
                >
                  <h3 className="text-base mb-[0.125rem] text-jiwe-dark-blue dark:text-grey-light">
                    {tournament.name}
                  </h3>
                  <h4 className="text-sm text-grey-dark">
                    {parseDateRange(
                      tournament.dates.tournamentDates.start,
                      tournament.dates.tournamentDates.end
                    )}
                  </h4>
                </button>
                <div className="">{/* Buttons */}</div>
              </div>
            )
          )
        ) : (
          <h4 className="text-xs text-grey-light uppercase">
            There are no tournaments on this day
          </h4>
        )}
      </div>
    </div>
  );
};

export default DateTournaments;
